module.exports = __webpack_public_path__ + "static/media/download.7efe5051.svg";